module.exports = __webpack_public_path__ + "img/goqus1.1e996c69.png";